import { render } from "./fekhastmoo.vue?vue&type=template&id=46cacf33"
import script from "./fekhastmoo.vue?vue&type=script&lang=js"
export * from "./fekhastmoo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/arair-kiosk-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__